import { z } from "zod"

export const powurOsEquipmentCostsSchema = z.object({
  id: z.number().int(),
  amount: z.number(),
  startDate: z.string(),
  endDate: z.nullable(z.string()),
  equipmentId: z.number().int(),
})
export type PowurOsEquipmentCost = z.infer<typeof powurOsEquipmentCostsSchema>
